export default __webpack_public_path__ + "static/media/nature-animal-wolf-wildernessPixabay.f5188aca.jpg";